export class ApiEndpoints {
    public static LOGIN = 'auth/login';
    public static REGISTER = 'auth/register';
    public static FORGOT_PASSWORD = 'auth/forgot-password';
    public static RESET_PASSWORD = 'auth/reset-password';
    public static USER = 'user';
    public static USER_UPDATE_PROFILE = 'user/updateProfile';
    public static USER_FIND_BY_CONTACT = 'user/find-by-contact'; // TODO REMOVE

    public static FILE_UPLOAD = 'file-upload';

    public static CONTACTS_GET = 'contacts';
    public static CONTACT_ADD = 'contacts';
    public static CONTACT_UPDATE = 'contacts/:id/update';
    public static CONTACT_BLOCK = 'contacts/:id/block';
    public static CONTACT_DELETE = 'contacts/:id';
    public static CONTACT_SEARCH = 'contacts/search';
    public static CONTACTS_SYNC = 'contacts/sync';
    public static CONTACTS_INVITE = 'contacts/invite';

    public static STATS_CURRENCIES = 'stats/currencies';
    public static STATS_POPULATION = 'stats/population';
    public static STATS_WEATHER = 'stats/weather';
    public static STATS_TIME = 'stats/time';
    public static STATS_LEAGUES = 'stats/leagues';
    public static STATS_NEWS = 'stats/news';

    public static VOICE_CALL_HISTORY = 'voice-call/history';

    public static NEWSLETTER = 'newsletter';
    public static CONTACT_US = 'contact-us';

    public static CHAT = 'chat';
    public static CHAT_RECENT = 'chat/recent';

    public static COUNTRIES = 'geography/countries';
    public static STATES = 'geography/countries/:countrycode/states';
    public static CITIES = 'geography/countries/:countrycode/states/:statecode/cities';

    public static NOTIFICATIONS = 'notifications';
}
